export const positions = [
  {
    position: "Marketing Officer",
    qualifications: [
      "Female",
      "20 to 30 years old",
      "Preferably a graduate of Marketing, Business Administration, Management or any related business course",
      "Willing to do field work",
      "Computer literate and self-driven",
      "Marketing experience a plus but not a requirement",
      "Resourceful and personable",
    ],
  },
  {
    position: "Account Officer",
    qualifications: [
      "Male",
      "20 to 30 years old",
      "College Graduate",
      "Willing to do field work",
      "Computer literate and self-driven",
      "Owns a motorcycle",
      "Must have driver's license (student license also acceptable)",
      "Street-smart and Resourceful",
      "Fresh graduates are welcome to apply",
    ],
  },
];
